import type { ExtractPropTypes } from 'vue'
export const cosRangePickerProps = () => ({
  startTime: {
    type: String
  },
  endTime: {
    type: String
  },
  value: {
    type: Array
  },
  autoTime: {
    type: Boolean,
    default: true // 是否补全00:00:00 23:59:59
  },
  showTime: {
    type: Boolean
  },
  placeholder: {
    type: Array,
    default: () => {
      return ['请选择', '请选择']
    }
  },
  view: {
    type: Boolean
  },
  valueFormat: {
    type: String
  },
  // 输出北京时间
  isOutputBeijingTime: {
    type: Boolean
  }
})
export type CosRangePickerProps = Partial<ExtractPropTypes<ReturnType<typeof cosRangePickerProps>>>
export default cosRangePickerProps
